import React, { cloneElement, Children, useCallback } from "react";
import { App, ConfigProvider } from "antd";
import { createRoot } from 'react-dom/client';
import { customTheme } from "common/customTheme";
import ErrorBox from "common/ErrorBox";

export const Main = () => {

    const ButtonTrigger = ({ children }) => {

        const handleClick = useCallback((id) => {
            console.log(`somebody is here! ID: ${id}`);
        }, []);

        return (
            <>
                {
                    Children.map(children, (child,index) => {
                        return (
                            <div className="mb-2">
                                {
                                    cloneElement(child, {
                                        onClick: () => handleClick(child.props['item-id']),
                                        className: 'btn btn-sm btn-light border'
                                    })
                                }
                            </div>
                        )

                    })
                }
            </>
        )
    }

    return (
        <div>
            <p>Vale por un test main.</p>

            <ButtonTrigger>
                <button id="bt1" item-id="1">
                    Click me!
                </button>
                <button id="bt2" item-id="2">
                    Click me!
                </button>
                <button id="bt3" item-id="3">
                    Click me!
                </button>
                <button id="bt4" item-id="4">
                    Click me!
                </button>
            </ButtonTrigger>
        </div>
    )
}

let main = document.getElementById('test-main');

if (main) {
    const root = createRoot(main);
    root.render(
        <React.StrictMode>
            <ErrorBox>
                <ConfigProvider theme={customTheme}>
                    <App >
                        <Main />
                    </App>
                </ConfigProvider>
            </ErrorBox>
        </React.StrictMode>
    );
}

